import { render, staticRenderFns } from "./ClientMemberApprovalManage.vue?vue&type=template&id=45400f54&scoped=true&"
import script from "./ClientMemberApprovalManage.vue?vue&type=script&lang=js&"
export * from "./ClientMemberApprovalManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45400f54",
  null
  
)

export default component.exports